import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

import {DictService} from '../../core/ecv-http-services/services/dict.service';
import {DictModel} from '../../dictionary/dict.model';
import {CustomValidators} from '../../core/validator/custom-validators';
import {BaseFillDataFormComponent} from '../../widgets/form-section/base-fill-data-form-component';
import {EcvLanguageService} from '../../core/ecv-language.service';


@Component({
  selector: 'app-cv-parsed-input',
  templateUrl: './cv-parsed-input.component.html'
})
export class CvParsedInputComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  cvParsedForm: FormGroup;
  dateForm: FormGroup;
  @Input() singleDict: boolean;
  @Input() dictionary: DictModel[] = [];
  @Input() inputLabel: string;
  @Input() hideDate: boolean;
  @Input() dictPropertyName: string;
  @Input() formControlName: string;

  constructor(private dictService: DictService,
              private langService: EcvLanguageService) {
    super();
  }

  ngOnInit() {
    this.createForm();
    if (this.singleDict) {
      this.dictService.getDictionary(this.data[this.dictPropertyName]).subscribe(response => {
        this.dictionary.push(response);
      });
    }
    this.cvParsedForm.markAsTouched();
    this.dateForm.markAsTouched();
  }

  private createForm() {
    this.dateForm = new FormGroup({
      'dateFrom': new FormControl('', CustomValidators.validateDateFormats),
      'dateTo': new FormControl('', CustomValidators.validateDateFormats)
    }, CustomValidators.validateDates('dateFrom', 'dateTo'));
    this.cvParsedForm = new FormGroup({
      'dict': new FormControl('', CustomValidators.notEmpty),
      'date': this.dateForm
    });
    this.parentForm.addControl('cvParsedForm' + this.dictPropertyName + this.formIndex, this.cvParsedForm);
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('cvParsedForm' + this.dictPropertyName + this.formIndex);
  }

  description(): string {
    if (!this.dictionary) {
      return '';
    }
    const dict = this.dictionary.find(x => x.id === this.data[this.dictPropertyName]);
    if (dict) {
      return this.langService.pickFromDictionary(dict);
    }
    return '';
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/cvs/cv-parsed-input/cv-parsed-input.component.ts